export default "__VITE_ASSET__2c42bcd5__"